import React from 'react';
import { Alert, AlertType } from '@yme/atoms/alert';
import { MiniButtonStyled } from './';
export const CycleSchemeAlert = (props) => {
    const { isRightToLeft, alertType = AlertType.INFO, message, onHandleClick, children } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Alert, { isRightToLeft: isRightToLeft, type: alertType, flexAlign: "flex-start", message: message, action: React.createElement(MiniButtonStyled, { isUnderlined: true, contentColor: "inherit", onClick: onHandleClick }, "Undo") }),
        children));
};
